import router from '@/router.js'
import axios from "axios"
import jwtdecoder from 'jsonwebtoken'
import { getApiUrl } from '@/utils/api.js'

var redirect = '/'
var error = null
var jwtCookieValidInMin = 120

let SYSTEM_ADMIN = "system_admin"
let CUSTOMER_USER = "customer_user"
let CUSTOMER_ADMIN = "customer_admin"
let CUSTOMER_MANAGER = "customer_manager"

export function requireAuth(to, from, next) {

    if (!isLoggedIn()) {

        redirect = to.path
        next({ path: '/login' })

    } else {

        next();
    }
}

export function doLogin(loginPage, account, password) {

    axios(
        { 
            method: 'POST', 
            'url': getApiUrl() + '/v0/login',
            data: {
                accountName: account,
                password: password
            }
        })
        .then(
            result => {
                
                setJwt(result.data.jwt, jwtCookieValidInMin)
                router.push(redirect)
            },
            error => {
                if (loginPage != null) loginPage.setError('Benutzer oder Passwort falsch!')
            }
        )
}

export function changeActiveRole(role, callBack) {

    axios(
        { 
            method: 'PUT', 
            'url': getApiUrl() + '/v0/activerole',
            headers: {
                'Authorization': 'Bearer ' + getJwt()
            },
            data: {
                roleAtCustomer: role
            }
        })
        .then(
            result => {
                setJwt(result.data.jwt, jwtCookieValidInMin)

                if (callBack != null) callBack()
            },
            error => {
                console.error(error.response.data.status)
            }
        )
}

export function setJwt(value, minutesValid) {

    var d = new Date();
    d.setTime(d.getTime() + (minutesValid * 60 * 1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = "jwt=" + value + ";" + expires + ";path=/";
}

export function getJwt() {

    var name = 'jwt='
    var decodedCookie = decodeURIComponent(document.cookie)
    var ca = decodedCookie.split(';')
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1)
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length)
        }
    }
    return null;
}

export function doLogout() {

    setJwt('', -10)
    router.push({ name: 'login' })
}

export function isLoggedIn() {

    return getJwt() != null && getJwt() !== ''
}

export function getCustomerId() {

    var token = decodeToken()

    return token.customerId
}

export function getUserId() {

    var token = decodeToken()

    return token.customerId
}

export function getCustomerName() {

    var token = decodeToken()

    console.log(token)

    return token.customerName
}

export function getAccountName() {

    var token = decodeToken()

    return token.sub
}

export function getRole(roles) {

    var token = decodeToken()

    if (token.system_admin) return SYSTEM_ADMIN
    if (token.customer_admin) return CUSTOMER_ADMIN
    if (token.customer_user) return CUSTOMER_USER
    if (token.customer_manager) return CUSTOMER_MANAGER
    
    return false
}

export function hasRole(roles) {

    var token = decodeToken()

    for (var ii = 0; ii < roles.length; ii++) {

        var role = roles[ii]

        if (role == SYSTEM_ADMIN && token.system_admin) return true
        if (role == CUSTOMER_ADMIN && token.customer_admin) return true
        if (role == CUSTOMER_MANAGER && token.customer_manager) return true
        if (role == CUSTOMER_USER && token.customer_user) return true
    }

    return false
}

export function decodeToken() {

    try {

        var jwt = getJwt()
        var token = jwtdecoder.verify(jwt, 'ght67hHHzgT801Smnaqwzgtr345')
        return token    

    } catch(err) {

        console.log(err)
        router.push('/login')
    }
}
